import * as React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const MultiplyBackground = React.memo(
  (props: {
    width?: number;
    height?: number;
    color?: string;
    containerStyle?: StyleProp<ViewStyle>;
  }) => {
    return (
      <View style={props.containerStyle}>
        <Svg
          width={props.width ?? 95}
          height={props.height ?? 97}
          viewBox="0 0 102 123"
          fill="none"
        >
          <Path
            d="M23.0002 96.8887L0.5 74.6471L25.0692 49.0434L0.5 23.4397L23.0002 1.19807L47.3108 26.2845L71.6214 0.939453L94.1216 23.4397L69.2938 49.0434L93.863 74.6471L71.6214 96.8887L47.3108 71.5436L23.0002 96.8887Z"
            fill={props.color ?? '#FFF5DD'}
            fillOpacity="0.95"
          />
        </Svg>
      </View>
    );
  },
);

export { MultiplyBackground };
